<template>
  <div class="webinar mt-5 mb-5">
    <div class="site-wrapper">
      <div class="main-wrapper">
        <div class="container-fluid">
          <div class="row mt-5 webinars pl-2 pr-2">
            <div class="title w-100 mb-3 mb-1 d-flex justify-content-between align-items-center">
              <h5 class="mb-0"><strong>Webinar khóa học</strong></h5>
              <button class="btn btn-primary btn-sm" @click="handleCreateWebinar">
                <b-icon-plus-circle-fill />
                <span class="pl-1"><strong>Tạo Webinar mới</strong></span>
              </button>
            </div>
            <hr class="mt-0 mb-4 w-100">
            <div class="container-fluid" v-loading="loading">
              <div class="row">
                <div v-if="webinars" class="col-12">
                  <ListWebinar
                    :teacher="user"
                    :webinars="webinars"
                    @edit-webinar="handleEditWebinar"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-if="webinarTemp"
      v-model="webinarDialog"
      title="Tạo webinar mới"
      ok-title="Lưu thay đổi"
      cancel-title="Hủy"
      size="lg"
      dialog-class="webinar-dialog"
      @ok="createWebinar"
    >
      <b-form v-loading="createLoading">
        <b-form-group
          label="Tiêu đề"
        >
          <b-form-input
            v-model="webinarTemp.name"
            required
          />
        </b-form-group>
        <b-form-group
          label="Link ảnh bìa"
        >
          <b-input-group>
            <b-form-input
              v-model="webinarTemp.thumbnail_url"
              required
            />
            <b-input-group-append>
              <b-button
                style="min-height: calc(1.5em + 0.75rem + 2px); height: calc(1.5em + 0.75rem + 2px)"
                @click="openUploadFileModal"
              >
                <b-icon-cloud-upload />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label="Link Zoom"
        >
          <b-form-input
            v-model="webinarTemp.url"
            required
          />
        </b-form-group>
        <b-row>
          <div class="col-6">
            <b-form-group
              label="Bắt đầu vào"
            >
              <el-date-picker
                style="width: 100%"
                v-model="webinarTemp.start_at"
                type="datetime"
              />
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group
              label="Kết thúc vào"
            >
              <el-date-picker
                style="width: 100%"
                v-model="webinarTemp.end_at"
                type="datetime"
              />
            </b-form-group>
          </div>
        </b-row>
        <b-form-group
          label="Khóa học"
        >
          <el-select
            v-model="webinarTemp.related_course_ids"
            :clearable="true"
            :multiple="true"
            style="width: 100%"
          >
            <el-option
              v-for="course in courses"
              :key="course._id"
              :value="course._id"
              :label="course.name"
            />
          </el-select>
        </b-form-group>
        <b-form-group
          label="Webinar liên quan"
        >
          <el-select
            v-model="webinarTemp.related_webinar_ids"
            :clearable="true"
            :multiple="true"
            style="width: 100%"
          >
            <el-option
              v-for="webinar in webinars"
              :key="webinar._id"
              :value="webinar._id"
              :label="webinar.name"
            />
          </el-select>
        </b-form-group>
        <b-form-textarea
          class="mt-2"
          id="textarea"
          v-model="webinarTemp.about"
          placeholder="Mô tả"
          rows="3"
          max-rows="6"
        />
      </b-form>
    </b-modal>

    <b-modal
      v-model="uploadDialog"
      title="Tải ảnh webinar"
      ok-title="Tải lên"
      cancel-title="Hủy"
      dialog-class="webinar-dialog"
      @ok="uploadThumbail"
    >
      <Upload
        :loading.sync="uploadLoading"
        @file="getUploadFile"
      />
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import ListWebinar from '@/components/ListWebinar'
import Upload from '@/components/Upload'
import { uploadWebinarThumbnail } from '@/api/data'

export default {
  components: {
    ListWebinar,
    Upload
  },

  computed: {
    ...mapGetters({
      user: 'user',
      courses: 'courses',
      webinars: 'webinars'
    })
  },

  data() {
    return {
      webinarTemp: null,
      webinarDialog: false,
      uploadDialog: false,
      uploadLoading: false,
      createLoading: false,
      actionType: '',
      file: null,
      loading: false
    }
  },

  created() {
    this.initWebinars()
    this.initCourses()
  },

  methods: {
    openUploadFileModal() {
      this.uploadDialog = true
      this.file = null
    },

    handleEditWebinar(webinar) {
      this.webinarTemp = _.cloneDeep(webinar)
      this.actionType = 'update'
      this.webinarDialog = true
    },

    uploadThumbail(event) {
      event.preventDefault()
      this.uploadLoading = true

      uploadWebinarThumbnail({
        file: this.file.raw
      })
        .then(data => {
          this.uploadLoading = false
          this.uploadDialog = false
          this.$set(this.webinarTemp, 'thumbnail_url', data.data.url)
          this.$bvToast.toast('Tải lên thành công', {
            title: 'Thành công',
            variant: 'success'
          })
        })
        .catch((error) => {
          this.uploadLoading = false
          this.$bvToast.toast(this.get(error, 'response.data.error.message') || error.message, {
            title: 'Thành công',
            variant: 'success'
          })
        })
    },

    getUploadFile(file) {
      this.file = file
    },

    handleCreateWebinar() {
      this.webinarTemp = {}
      this.actionType = 'create'
      this.webinarDialog = true
    },

    createWebinar(event) {
      event.preventDefault()
      this.createLoading = true
      if (this.actionType === 'create') {
        this.$store.dispatch('course/CreateWebinar', this.webinarTemp).then(data => {
          this.createLoading = false
          this.webinarDialog = false
          this.$bvToast.toast(`Tạo webinar ${this.webinarTemp.name} thành công`, {
            title: 'Thành công',
            variant: 'success'
          })
        }).catch(error => {
          this.createLoading = false
          this.$bvToast.toast(this.get(error, 'response.data.error.message') || error.message, {
            title: 'Thất bại',
            variant: 'danger'
          })
        })
      } else if (this.actionType === 'update') {
        this.$store.dispatch('course/UpdateWebinar', this.webinarTemp).then(data => {
          this.createLoading = false
          this.webinarDialog = false
          this.$bvToast.toast(`Cập nhật webinar ${this.webinarTemp.name} thành công`, {
            title: 'Thành công',
            variant: 'success'
          })
        }).catch(error => {
          this.createLoading = false
          this.$bvToast.toast(this.get(error, 'response.data.error.message') || error.message, {
            title: 'Thất bại',
            variant: 'danger'
          })
        })
      }
    },

    async initWebinars() {
      this.loading = true
      await this.$store.dispatch('course/GetWebinars', {})
      this.loading = false
    },

    async initCourses() {
      if (!this.courses) {
        await this.$store.dispatch('course/GetCourses', {
          sort: '-end_at'
        })
      }
    },

    get(obj, path) {
      return _.get(obj, path)
    }
  }
}
</script>

.<style lang="scss">
.webianr-dialog {
  .btn-primary {
    background-color: #FF5A8D;
    border-color: #FF5A8D;
  }
}
</style>
